import { Stack, useMediaQuery } from '@ltvco/refresh-lib/theme';
import { useContext } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';

import {
  ChatPageContainer,
  ChatPageMessagesContainer,
  ReportColumn,
} from 'components/ChatBV/components';
import { ChatLayoutContext } from 'components/ChatBV/context';

import { DeepSearchSidebar } from './Sidebar/DeepSearchSidebar';

interface DeepSearchLayoutProps {
  onLogout: () => void;
}

export const DeepSearchLayout = ({ onLogout }: DeepSearchLayoutProps) => {
  const navigate = useNavigate();
  const isMobile = useMediaQuery('(max-width: 1024px)');
  const { reportState } = useContext(ChatLayoutContext);
  const {
    openReport,
    permalink,
    reportData,
    type,
    handleCloseReport,
    handleRelatedReportClick,
  } = reportState;

  const handleRecentReportsClick = () => {
    navigate('/deepsearch/chat/library');
  };

  const handleAccountClick = () => {
    navigate('/deepsearch/account');
  };

  const handleUpgradePlanClick = () => {
    navigate('/deepsearch/upgrade/plan');
  };

  const currentWidth = '500px';

  return (
    <ChatPageContainer>
      <DeepSearchSidebar
        onRecentReportsClick={handleRecentReportsClick}
        onAccountClick={handleAccountClick}
        onUpgradePlanClick={handleUpgradePlanClick}
        onLogout={onLogout}
      />
      <Stack
        direction={openReport ? 'row' : 'column'}
        width="100%"
        height="100%"
        spacing={0}
        sx={{
          minWidth: 0,
          overflow: 'hidden',
          ...(openReport && !isMobile && { gap: '40px' }),
        }}
      >
        <ChatPageMessagesContainer
          sx={{
            width: openReport && !isMobile ? '60%' : '100%',
            height: openReport ? '98%' : '100%',
            minWidth: 0,
            overflow: 'hidden',
            ...(openReport && isMobile && { width: 0, flexShrink: 1 }),
          }}
        >
          <Outlet />
        </ChatPageMessagesContainer>
        {openReport && (
          <ReportColumn
            reportData={reportData}
            onClose={handleCloseReport}
            permalink={permalink}
            currentWidth={isMobile ? '100%' : currentWidth}
            handleRelatedReportClick={handleRelatedReportClick}
            type={type}
          />
        )}
      </Stack>
    </ChatPageContainer>
  );
};
